import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from '../styles/modal.module.css'
import { toast } from 'react-toastify';
import StateContext from '../context/state/StateContext';
import UserContext from '../context/user/UserContext';
import axios from 'axios';
import { FaLink } from "react-icons/fa6";
import { AiOutlineFolderOpen } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoMdAlarm } from "react-icons/io";
import { IoFlag } from "react-icons/io5";
import { IoCheckmarkSharp } from "react-icons/io5";
import { IoIosMic } from "react-icons/io";
import Links from './Links';
import useVoiceRecorder from './useVoiceRecorder';
import { FaRegCircleStop } from "react-icons/fa6";
import CustomReminder from './CustomReminder';
import { IoSearch } from "react-icons/io5";
import Fuse from 'fuse.js';
import Dropdown from './Dropdown';

const AddTicket = (props) => {

    const { isRecording, audioBlob, startRecording, stopRecording } = useVoiceRecorder();
    const { ticket, setTicket, setTickets, token, employees, setEmployees, setLoading, groupDetails, reminderData, setReminderData } = useContext(StateContext)
    const { user, getEmployees, fetchGroupDetails } = useContext(UserContext)
    const [select, setSelect] = useState('');
    const [drop, setDrop] = useState(Array(2).fill(false));
    const [disabled, setDisabled] = useState(true);
    const [assigned, setAssigned] = useState([]);
    const [clientName, setClientName] = useState({ id: '', name: '' });
    const [error, setError] = useState('');
    const [fields, setFields] = useState({ component: '', open: false });
    const [link, setLink] = useState('');
    const [links, setLinks] = useState([]);
    const [files, setFiles] = useState([]);
    const [priority, setPriority] = useState('Low');
    const [dateTime, setDateTime] = useState({ date: '', time: '' });
    const [repeat, setRepeat] = useState('does_not_repeat')
    const [repeatChecked, setRepeatChecked] = useState(false);
    const [group, setGroup] = useState([])
    const [allEmployees, setAllEmployees] = useState([]);
    const [acknowledge, setAcknowledge] = useState({
        employees: [],
        assigned: []
    })
    const navigate = useNavigate();


    useEffect(() => {
        const emp = employees.filter(item => item.role !== "agency")
        setAllEmployees(emp)
        setAcknowledge((prev) =>{
            return {
                ...prev,
                employees: emp 
            }
        })
    }, [])


    const handleDrop = (index) => {
        const array = [...drop]
        array[index] = !drop[index]
        setDrop(array)
    }

    const handleChange = (e) => {
        setDisabled(false)
        setError('')
        setTicket({ ...ticket, [e.target.name]: e.target.value })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading({ open: true, text: "Adding" })

            const formData = new FormData();
            formData.append('title', ticket.title);
            formData.append('clientId', clientName.name ? clientName.id : user.id);
            formData.append('description', ticket.description);
            formData.append('category', select);
            formData.append('employeeId', JSON.stringify(assigned.map(emp => emp.id)));
            formData.append('acknowledgeId', JSON.stringify(acknowledge.assigned.map(emp => emp.id)));
            formData.append('links', JSON.stringify(links));
            formData.append('priority', priority);
            formData.append('date', dateTime.date);
            formData.append('time', dateTime.time);
            formData.append('group', group.id);

            if (audioBlob !== null) {
                formData.append('audio', audioBlob, 'voice-recording.wav');
            }
            formData.append("repeat", repeat)
            if (reminderData !== null) {
                formData.append('repeatData', JSON.stringify(reminderData))
                setReminderData(null);
            }

            if (files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    formData.append('uploads', files[i]);
                }
            }

            const response = await axios.post(
                process.env.REACT_APP_API_URL + "api/ticket/add",
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'auth-token': `${token}`
                    }
                }
            );
            const json = response.data;
            if (json.success) {
                toast.success(json.message)
                props.close({ open: false, component: '' })
                navigate("/dashboard");
            } else {
                toast.error(json.error || json.message)
                setError(json.message || json.message[0].msg)
            }

        } catch (error) {
            console.log(error);
            // setError(error.response.data.message || error.response.data.message[0].msg)
            toast.error(error)
            setError(error.response.data.message)
        } finally {
            setLoading({ open: false, text: '' })
        }
    }

    // sending notiification erheree
    const todayDate = () => {
        let date = new Date();
        return date.getDate();
    };

    const handleDate = (e) => {
        let date = new Date(e.target.value);
        if (date.getDay() === 0) {
            toast.error("Sundays are not allowed please select another day.")
            return
        }
        setDisabled(false)
        setDateTime({ ...dateTime, [e.target.name]: e.target.value })
    }

    const handleFileChange = (event) => {
        const fileList = event.target.files;

        // Convert FileList to Array and limit it to 5 files
        // const fileArray = Array.from(fileList).slice(0, 5);

        if (fileList.length > 5) {
            setError('You can only upload a maximum of 5 files.');
        } else {
            setError('');
            setFiles(fileList); // Update state with valid files
        }
    };


    const smallComponent = () => {
        if (fields.component === "links") {
            return <Links close={setFields} open={fields} disabled={setDisabled} link={link} setLink={setLink} links={links} setLinks={setLinks} />
        } else if (fields.component === "custom") {
            return <CustomReminder close={setFields} open={fields} />
        }
    }

    const today = new Date();
    const dayOfWeek = today.toLocaleString('default', { weekday: 'long' });

    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const getNthWeekday = (date) => {
        const dayOfWeek = date.getDay(); // Sunday is 0, Monday is 1, etc.
        const dayOfMonth = date.getDate();

        // Calculate how many times this day has occurred so far in the month
        const nthOccurrence = Math.ceil(dayOfMonth / 7);

        // Array to map weekday numbers to names
        const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        return `${nthOccurrence} ${weekdays[dayOfWeek]}`; // e.g., "2nd Monday"
    };


     const assignedDrop = (current, action) => {
        const { id, username } = current;
        if (action === 'add') {
            // Add the item to the assigned list
            setAssigned(prev => [...prev, {id, username }]);
            setAcknowledge((prev) => {
                return {
                    ...prev,
                    employees: prev.employees.filter(item => item.username !== username),
                }
            })
        } else if (action === 'remove') {
            // Remove the item from the assigned list
            setAssigned(prev => prev.filter(item => item.username !== username));
            setAcknowledge(prev => ({
                ...prev,
                employees: [
                    allEmployees.find(item => item.username === username),
                    ...prev.employees
                ]
            }));
            setGroup([])
        }
        setDisabled(false)
                // setDrop(false)
        setError('')
    }

    const handleAcknowledge = (current, action) => {
        const { id, username } = current;
        if (action === 'add') {
            // Add the item to the assigned list
            setAcknowledge((prev) => {
                return { 
                    ...prev,
                    assigned: [...prev.assigned, {id, username }]
                }
            });
        } else if (action === 'remove') {
            // Remove the item from the assigned list
            setAcknowledge((prev) => {
                return { 
                    ...prev,
                    assigned: prev.assigned.filter(item => item.username !== username)
                }
            });
        }
        setDisabled(false)
        setError('')
    }

    const handleGroupClick = (current, action) => {
        const teamEmployees = employees.filter(item => item.role !== "agency");

        if (!current) {
            setAllEmployees(teamEmployees);
            setAssigned([]);
            setGroup([]);
            return;
        }

        if (action === 'add') {
            setGroup(prev => [...prev, { id: current.id, name: current.name }]);

            const groupUsers = current.users
            .map(userRef => teamEmployees.find(emp => emp.id === userRef.id))
            .filter(Boolean); // remove nulls

            const assignedList = groupUsers.map(({ id, username }) => ({ id, username }));

            // Reorder groupUsers: assigned users first
            const orderedUsers = [...allEmployees].sort((a, b) => {
            const aAssigned = assignedList.find(user => user.id === a.id);
            const bAssigned = assignedList.find(user => user.id === b.id);
            return aAssigned && !bAssigned ? -1 : !aAssigned && bAssigned ? 1 : 0;
            });

            setAssigned(assignedList);
            setAllEmployees(orderedUsers);

        } else if (action === 'remove') {
            setGroup(prev => prev.filter(g => g.id !== current.id));

                // Remove assigned users that belong to this group
            const groupUserIds = current.users.map(user => user.id);

            setAssigned(prev =>
                prev.filter(user => !groupUserIds.includes(user.id))
            );
        }
    };

    return (
        <>
            <div className={`${styles.smallDrop} ${fields.open ? styles.active : ''} `}></div>
            <div className={`${styles.small_modal} ${fields.open ? styles.active : ''}`}>
                {smallComponent()}
            </div>
            <div className={styles.head}>
                <h3>Add Task</h3>
                <i className={`bx bx-x ${styles.close}`} onClick={() => props.close({ open: false, component: '' })}></i>
            </div>
            <form action="" className='h-100' onSubmit={handleSubmit}>
                <div className={styles.form_container}>
                    <div className="inputField" style={{ border: "1px solid #ddd" }}>
                        <input type="text" name='title' placeholder='Enter a Title*' onChange={handleChange} required />
                    </div>
                    <div className="row">                    
                        <div className="col-md-6 col-12 pe-md-2">
                            <div className="inputField" style={{ border: "1px solid #ddd" }}>
                                <input type="text" name='category' placeholder='Enter a category*' onChange={(e) => { setSelect(e.target.value) }} required />
                            </div>
                        </div>
                        <div className="row pe-0">
                            <label htmlFor="" className='mb-1 label fw-semibold'>Add User or a Group</label>
                            <div className="col-md-6 col-12 pe-0">
                                <Dropdown
                                    style={{zIndex: "9999"}}
                                    items={groupDetails}
                                    assigned={group}
                                    labelKey="name"
                                    title="Select Groups"
                                    placeholder="Search groups..."
                                    fuseKeys={["name"]}
                                    idPrefix = "group"
                                    assignedDrop={handleGroupClick}
                                    />
                            </div>
                            <div className="col-md-6 col-12 pe-0" >
                                <Dropdown
                                    style={{zIndex: "999"}}
                                    items={allEmployees}
                                    assigned={assigned}
                                    labelKey="username"
                                    title="Assign Employees"
                                    placeholder="Search employees..."
                                    fuseKeys={["username"]}
                                    idPrefix = "employee"
                                    assignedDrop={assignedDrop}
                                    />
                            </div>
                            <div className="col-md-6 col-12 pe-0">
                                <Dropdown
                                    style={{zIndex: "99"}}
                                    items={acknowledge.employees}
                                    assigned={acknowledge.assigned}
                                    labelKey="username"
                                    title="Assign Acknowledged Employees"
                                    placeholder="Search employees..."
                                    fuseKeys={["username"]}
                                    idPrefix = "acknowledge"
                                    assignedDrop={handleAcknowledge}
                                    />
                            </div>
                        </div>
                    </div>
                    <div className="inputField" style={{ border: "1px solid #ddd", borderRadius: "12px" }}>
                        <textarea name="description" onChange={handleChange} id="" placeholder='Enter a Description*' rows={5} required></textarea>
                    </div>
                    <div className="row">
                        <label htmlFor="" className='mb-1 label fw-semibold'>Due Date</label>
                        <div className="col-md-6 col-12">
                            <div className="inputField" style={{ border: "1px solid #ddd" }}>
                                <input type="date" placeholder='Select Date' name='date' max={todayDate} value={dateTime.date} onChange={handleDate} required />
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <div className="inputField" style={{ border: "1px solid #ddd" }}>
                                <input type="time" placeholder='Select Time' name='time' value={dateTime.time} onChange={handleDate} required />
                            </div>
                        </div>
                    </div>

                    <div className="inputField priority" style={{ gap: "6px" }}>
                        <span className={styles.tag}>
                            <IoFlag />
                            <p>Priority</p>
                        </span>
                        <span onClick={() => { setPriority('High') }} className={`${styles.tag} ${priority == "High" ? styles.active : ""}`}>
                            <IoCheckmarkSharp />
                            <p>High</p>
                        </span>
                        <span onClick={() => { setPriority('Medium') }} className={`${styles.tag} ${priority == "Medium" ? styles.active : ""}`}>
                            <IoCheckmarkSharp />
                            <p>Medium</p>
                        </span>
                        <span onClick={() => { setPriority('Low') }} className={`${styles.tag} ${priority == "Low" ? styles.active : ""}`}>
                            <IoCheckmarkSharp />
                            <p>Low</p>
                        </span>
                    </div>
                    <div className={styles.repeat}>
                        <div className="checkbox-wrapper-4">
                            <input
                                type="checkbox"
                                checked={repeatChecked}
                                className="inp-cbx"
                                onChange={() => setRepeatChecked(!repeatChecked)}  // Toggle checkbox state
                                id="repeat-checkbox"  // Unique id for input
                            />
                            <label htmlFor="repeat-checkbox" className="cbx">
                                <span><svg></svg></span>
                                <span className='text'>Repeat</span>
                            </label>
                        </div>

                        {/* Conditionally render the dropdown based on the checkbox state */}
                        {repeatChecked &&
                            <div className={`w-100 dropdown ${drop[0] ? 'active' : ''}`}
                                onClick={() => handleDrop(0)}>
                                <div className="select">
                                    <div className="d-flex align-items-center">
                                        <span>{repeat ? repeat : "Does Not Repeat"}</span>
                                    </div>
                                    <i className="fa-solid fa-angle-up"></i></div>
                                <ul>
                                    <li onClick={() => { setRepeat("does_not_repeat") }}>Does not repeat</li>
                                    <li onClick={() => { setRepeat("daily") }}>Daily</li>
                                    <li onClick={() => { setRepeat("weekly") }}>Weekly on {dayOfWeek}</li>
                                    <li onClick={() => { setRepeat("monthly") }}>Monthly on the {getNthWeekday(new Date())}</li>
                                    <li onClick={() => { setRepeat("weekday") }}>Every weekday (Monday to Friday)</li>
                                    <li onClick={() => { setRepeat("custom"); setFields({ component: 'custom', open: true }) }}>Custom Recurrence</li>
                                </ul>
                            </div>
                        }
                    </div>

                    {error ? <p style={{ color: "red" }}>{error}</p> : null}
                    <p className={styles.para}>You can upload up to 5 files</p>
                    <div className="d-flex align-items-center flex-wrap" style={{ gap: "15px" }}>
                        <div className={styles.icon} data-attr="Add Links" onClick={() => { setFields({ component: "links", open: true }) }}>
                            {links.length > 0 && <span>{links.length}</span>}
                            <FaLink />
                        </div>
                        <label htmlFor='upload' className={styles.icon} data-attr="Upload Files">
                            <input type="file" style={{ display: "none" }} onChange={handleFileChange} multiple id='upload' />
                            <AiOutlineFolderOpen />
                        </label>
                        {files.length > 0 ?
                            <div className={styles.files}>
                                {Array.from(files).map((item, index) => {
                                    return <span key={index} className={styles.file}>{item.name}{files.length > index ? ',' : null}</span>
                                })}
                            </div> : null}
                        {!isRecording ? (
                            <div className={styles.icon} data-attr="Start Recording" onClick={() => { startRecording(); setDisabled(false) }}>
                                <IoIosMic />
                            </div>
                        ) : (
                            <div className={styles.icon} data-attr="Stop Recording" onClick={stopRecording}>
                                <FaRegCircleStop />
                            </div>
                        )}
                        {audioBlob && (
                            <div>
                                <audio controls src={URL.createObjectURL(audioBlob)} />
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.foot}>
                    <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                        <button type='button' className="button2 outline" onClick={() => props.close({ open: false, component: '' })}>Cancel</button>
                        <button type='submit' className={`button2 ${disabled ? 'disabled' : ''}`} disabled={disabled}>Add</button>
                    </div>
                </div>
            </form>

        </>
    )
}

export default AddTicket
